<template>
  <span style="text-align: left">
    <template v-if="modo == 'new' || modo == 'edit' || modo == 'flow'">
      <v-text-field
        v-bind:value="preLoad(value)"
        v-on:input="(event) => $emit('input', preUpdate(event))"
        required
        :rules="crud.evalrules(campo)"
        type="password"
        :hint="T(campo.cmp_dica)"
        persistent-hint
        browser-autocomplete="new-password"
        solo
        dark
      ></v-text-field>
    </template>

    <template v-if="modo == 'list' || modo == 'view' || modo == 'viewmode'">
      <span :class="{ 'text-xs-center': modo == 'list' }">{{
        displayvalue
      }}</span>
    </template>
  </span>
</template>

<script>
try {
  var _baseComponent = require("@/lib/componente/_base.vue").default;
} catch (err) {
  var _baseComponent = require("@/framework/lib/componente/_base.vue").default;
}
export default {
  extends: _baseComponent,
  data() {
    return {};
  },
  methods: {
    preLoad(myval) {
      return myval;
    },
    preUpdate(myval) {
      return myval;
    },
  },
};
</script>

<style scoped></style>
